import _ from 'lodash';
import api from '../api/apcApi';


import {
  UNDO_REQUEST,
  APPROVE_REQUEST,
  APPROVED_REQUEST,
  REJECT_REQUEST,
  REJECTED_REQUEST,
  THROW_ERROR,
} from '../constants';

// Approves a specific access request.
export const approveRequest = (contactId) => async (dispatch) => {
  dispatch({ type: APPROVE_REQUEST, payload: contactId });

  const requestPayload = {
    requests: [
      {
        contactId,
        actionType: 'Approved',
      },
    ],
  };

  try {
    const response = await api.post('/v1/contact/approvals?programType=APC', requestPayload,
      {
        headers:
        {
          Authorization: `Bearer ${window.adobeIMS.getAccessToken().token}`,
          'x-api-key': window.apcConfig.adobeIO.apiKey,
          // Prefer: 'example=success',
        },
      });

    if (response.data.length
      && _.find(response.data, (o) => o.recId === contactId)
      && _.find(response.data, (o) => o.recId === contactId).success) {
      dispatch({ type: APPROVED_REQUEST, payload: contactId });
    } else {
      dispatch({ type: UNDO_REQUEST, payload: contactId });
      dispatch({ type: THROW_ERROR, payload: { messagePath: 'workflow.error_page.admin_action_problem' } });
      window.console.error('Error: Problem approving request, payload did not have success message.', response);
      if (window.newrelic) {
        window.newrelic.noticeError('Object key is false instead of true',
          {
            page: 'Admin Page',
            api: '/v1/contact/approvals',
            action: 'approve',
            fatal: false,
            user: window.adobeIMS.getUserProfile().email,
            response: response.data,
          });
      }
    }
  } catch (error) {
    dispatch({ type: UNDO_REQUEST, payload: contactId });
    dispatch({ type: THROW_ERROR, payload: { messagePath: 'workflow.error_page.admin_action_problem' } });
    window.console.error('Error: Problem approving request, API call failed.', error);
    if (window.newrelic) {
      window.newrelic.noticeError(error.message,
        {
          page: 'Admin Page',
          api: '/v1/contact/approvals',
          action: 'approve',
          fatal: false,
          user: window.adobeIMS.getUserProfile().email,
        });
    }
  }
};

// Rejects a specific access request.
export const rejectRequest = (contactId) => async (dispatch) => {
  dispatch({ type: REJECT_REQUEST, payload: contactId });

  const requestPayload = {
    requests: [
      {
        contactId,
        actionType: 'Rejected',
      },
    ],
  };

  try {
    const response = await api.post('/v1/contact/approvals?programType=APC', requestPayload,
      {
        headers: {
          Authorization: `Bearer ${window.adobeIMS.getAccessToken().token}`,
          'x-api-key': window.apcConfig.adobeIO.apiKey,
          // Prefer: 'example=success',
        },
      });

    if (response.data.length
        && _.find(response.data, (o) => o.recId === contactId)
        && _.find(response.data, (o) => o.recId === contactId).success) {
      dispatch({ type: REJECTED_REQUEST, payload: contactId });
    } else {
      dispatch({ type: UNDO_REQUEST, payload: contactId });
      dispatch({ type: THROW_ERROR, payload: { messagePath: 'workflow.error_page.admin_action_problem' } });
      window.console.error('Error: Problem rejecting request, payload did not have success message.', response);
      if (window.newrelic) {
        window.newrelic.noticeError('Object key is false instead of true',
          {
            page: 'Admin Page',
            api: '/v1/contact/approvals',
            action: 'reject',
            fatal: false,
            user: window.adobeIMS.getUserProfile().email,
            response: response.data,
          });
      }
    }
  } catch (error) {
    dispatch({ type: UNDO_REQUEST, payload: contactId });
    dispatch({ type: THROW_ERROR, payload: { messagePath: 'workflow.error_page.admin_action_problem' } });
    window.console.error('Error: Problem rejecting request, API call failed.', error);
    if (window.newrelic) {
      window.newrelic.noticeError(error.message,
        {
          page: 'Admin Page',
          api: '/v1/contact/approvals',
          action: 'reject',
          fatal: false,
          user: window.adobeIMS.getUserProfile().email,
        });
    }
  }
};
